import {
  Crown, LineChart, Target, PenTool, Megaphone, Share2, Sparkles,
} from "lucide-react";

export const AGENTS = [
  {
    id: "ceo",
    nome: "CEO / Orquestrador",
    cargo: "Diretor de Operações e Delegação",
    desc: "Recebe os objetivos, divide em tarefas, delega ao especialista certo e consolida a entrega final.",
    icon: Crown,
    color: "#8B5CF6",
    badge: "bg-purple-950/60 text-purple-300 border-purple-700/50",
    ring: "rgba(139,92,246,0.25)",
  },
  {
    id: "analista",
    nome: "Analista de Conteúdo",
    cargo: "Inteligência de Conteúdo e Dados",
    desc: "Analisa desempenho e entrega DADOS → DIAGNÓSTICO → OPORTUNIDADE → AÇÃO.",
    icon: LineChart,
    color: "#06B6D4",
    badge: "bg-cyan-950/60 text-cyan-300 border-cyan-700/50",
    ring: "rgba(6,182,212,0.25)",
  },
  {
    id: "marketing",
    nome: "Especialista em Marketing",
    cargo: "Estrategista de Marketing Digital",
    desc: "Define posicionamento, pilares, funil, campanhas e a estratégia mensal.",
    icon: Target,
    color: "#10B981",
    badge: "bg-emerald-950/60 text-emerald-300 border-emerald-700/50",
    ring: "rgba(16,185,129,0.25)",
  },
  {
    id: "copy",
    nome: "Prompt & Copywriter",
    cargo: "Prompt Engineer + Copywriter",
    desc: "Cria hooks, roteiros, headlines, storytelling e textos persuasivos de venda.",
    icon: PenTool,
    color: "#F59E0B",
    badge: "bg-amber-950/60 text-amber-300 border-amber-700/50",
    ring: "rgba(245,158,11,0.25)",
  },
  {
    id: "postagens",
    nome: "Especialista em Postagens",
    cargo: "Social Media + Copy de Publicação",
    desc: "Transforma a estratégia em publicações prontas: legendas, CTAs e hashtags.",
    icon: Megaphone,
    color: "#EC4899",
    badge: "bg-pink-950/60 text-pink-300 border-pink-700/50",
    ring: "rgba(236,72,153,0.25)",
  },
  {
    id: "social",
    nome: "Social Media Multiplataforma",
    cargo: "Adaptação por Plataforma",
    desc: "Adapta cada conteúdo para Instagram, TikTok e Facebook — nunca copia igual.",
    icon: Share2,
    color: "#3B82F6",
    badge: "bg-blue-950/60 text-blue-300 border-blue-700/50",
    ring: "rgba(59,130,246,0.25)",
  },
  {
    id: "criativo",
    nome: "Diretor Criativo",
    cargo: "Diretor de Criatividade e Conteúdo",
    desc: "Gera ideias de Reels, TikToks, carrosséis, séries e conteúdos virais.",
    icon: Sparkles,
    color: "#6366F1",
    badge: "bg-indigo-950/60 text-indigo-300 border-indigo-700/50",
    ring: "rgba(99,102,241,0.25)",
  },
];

export const PIPELINE_STEPS = [
  { key: "briefing", label: "Briefing", agent: "ceo" },
  { key: "diagnostico", label: "Diagnóstico", agent: "analista" },
  { key: "estrategia", label: "Estratégia", agent: "marketing" },
  { key: "ideias", label: "Ideias", agent: "criativo" },
  { key: "copy", label: "Copy & Roteiro", agent: "copy" },
  { key: "publicacao", label: "Publicação", agent: "postagens" },
  { key: "adaptacao", label: "Adaptação Multiplataforma", agent: "social" },
  { key: "revisao", label: "Revisão", agent: "ceo" },
  { key: "pacote", label: "Pacote Final", agent: "ceo" },
];

export const PLATFORM_STYLE = {
  Instagram: { badge: "bg-amber-950/50 text-amber-300 border-amber-700/50", dot: "#F59E0B" },
  TikTok: { badge: "bg-pink-950/50 text-pink-300 border-pink-700/50", dot: "#FF0050" },
  Facebook: { badge: "bg-blue-950/50 text-blue-300 border-blue-700/50", dot: "#3B82F6" },
};
